/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { LuisConstants } from 'src/core/utils/LuisConstants';

export const hasOwnerRole = (rolesIds: string[]) => rolesIds.some(id => id === LuisConstants.Azure.AzureRoleDefinitionId.Owner);
export const hasReaderRole = (rolesIds: string[]) => rolesIds.some(id => id === LuisConstants.Azure.AzureRoleDefinitionId.Reader);
export const hasStorageBlobDataContributorRole = (rolesIds: string[]) =>
    rolesIds.some(id => id === LuisConstants.Azure.AzureRoleDefinitionId.StorageBlobDataContributor);

export type UserAction =
    | 'canRead'
    | 'canWrite'
    | 'canTest'
    | 'canDeleteData'
    | 'canDeleteProject'
    | 'canDeployProject'
    | 'canManageAzureResoruces'
    | 'canListResourceKeys'
    | 'canChangeAppSettingsAndDetails';

export type UserActions = {
    [key in UserAction]: boolean;
};

export const defaultUserActions: UserActions = {
    canRead: false,
    canWrite: false,
    canTest: false,
    canDeleteData: false,
    canDeleteProject: false,
    canDeployProject: false,
    canManageAzureResoruces: false,
    canListResourceKeys: false,
    canChangeAppSettingsAndDetails: false
};

export const mapUserRoleToUserActions = (user: string): UserActions => {
    let userActions: UserActions = { ...defaultUserActions };
    switch (user) {
        case 'reader': {
            userActions.canRead = true;
            userActions.canTest = true;
            break;
        }
        case 'writer': {
            userActions = mapUserRoleToUserActions('reader');
            userActions.canWrite = true;
            userActions.canDeleteData = true;
            break;
        }
        case 'owner':
        default: {
            Object.keys(userActions).forEach((key: UserAction) => {
                userActions[key] = true;
            });
        }
    }

    return userActions;
};
